export default "/assets/d5f428264a2f450f.png"